import { z } from "zod";

import { imageSchema } from "@/services/cms";

export const defaultMediaSchema = z.object({
  url: z.string().min(3),
  title: z.string().min(3),
  width: z.number().positive().nullable().default(null),
  height: z.number().positive().nullable().default(null),
});

export const mediaSchema = z.union([defaultMediaSchema, imageSchema]);
